/**
 * Keep all copilot layers strictly below 10 so default bottom sheets win without
 * per-modal wrappers.
 */
export const CHAT_FAB_Z_INDEX = 6;
export const CHAT_BACKDROP_Z_INDEX = 7;
export const CHAT_PANEL_Z_INDEX = 8;
